export default __webpack_public_path__ + "static/media/Skorobogatova_Olga_Nikolaevna.cad7724f.webp";